/// <reference path="../../../../../../typings/index.d.ts" />
///<reference path="../../yield-management-strategy.module.ts"/>


module Meevo.Plugins.YieldManagementStrategy {

    export interface ILocationAvailability {
        id: number;
        inTransfering: boolean;
        locationId: number;
        storeName: string;
    }

    export class LocationSelector {

        static $inject = [
            '$mdDialog',
            'meevo.components.common.DataService',
            'selectedItems'
        ];

        rightArray: ILocationAvailability[] = [];
        leftArray: ILocationAvailability[] = [];
        selectedCity;
        selectedState;
        selectedLocationGroup;

        searchCriteria = {
            zipCode: null,
            storeName: null,
            filterBySessionUser: true,
            locationStatus: [
                Meevo.Model.LocationStatusEnum.Active,
                Meevo.Model.LocationStatusEnum.ClosingPlanned,
                Meevo.Model.LocationStatusEnum.TemporarilyClosed,
                Meevo.Model.LocationStatusEnum.Closed
            ],
            subscriptionStatus: [Meevo.Model.SubscriptionStatusEnum.Active]
        };
        cityCriteria;

        get requestData() {
            return {
                criteria: {
                    ...this.searchCriteria,
                    city: this.selectedCity ? this.selectedCity.city : null,
                    state: this.selectedState ? this.selectedState.state : null,
                    locationGroupId: this.selectedLocationGroup ? this.selectedLocationGroup.id : null,
                },
                pageNumber: 0,
                itemsPerPage: 100000,
                sortBy: '',
                sortDirection: Model.SortDirection.Ascending,
                includeActive: true,
                includeDeleted: false,
                includeInactive: false,
            };
        }

        constructor(
            private $mdDialog: angular.material.IDialogService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            selectedItems: number[]
        ) {
            this.search(selectedItems);
        }

        apply() {
            this.$mdDialog.hide(this.rightArray.map((item) => item.id));
        }

        cancel() {
            this.$mdDialog.cancel();
        }

        selectedStateChanged() {
            this.selectedCity = null;
            this.cityCriteria = this.selectedState ? {state: this.selectedState.state} : {};
        }

        reset() {
            this.selectedState = null;
            this.selectedCity = null;
            this.selectedLocationGroup = null;
            this.cityCriteria = {};
            this.searchCriteria.zipCode = null;
            this.searchCriteria.storeName = null;

            this.search();
        }

        search(selectedItems?: number[]) {
            this.dataService.getListPaged('location/availability', this.requestData)
                .then((result: ILocationAvailability[]) => {
                    if (Array.isArray(selectedItems)) {
                        this.rightArray = result.filter((item) => selectedItems.indexOf(item.id) !== -1);
                    }
                    this.leftArray = result.filter((l) => this.rightArray.findIndex((r) => r.id === l.id) === -1);
                });

        }
    }

    angular.module('meevo.plugins.yieldManagementStrategy')
        .controller('meevo.plugins.yieldManagementStrategy.LocationSelector', LocationSelector);
}
